import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { Evento } from 'src/app/eventos/evento.model';
import { GoogleAnalyticService } from 'src/app/eventos/google-analytic/google-analytic.service';
import { MetaPixelService } from 'src/app/eventos/meta-pixel/meta-pixel.service';
import { Foto } from 'src/app/models/foto.model';
import { Orden } from 'src/app/models/orden.model';
import { EventoDataService } from 'src/app/service/data/evento-data.service';
import { OrdenDataService } from 'src/app/service/data/orden-data.service';
import { HardcodedAutheticationService } from 'src/app/service/hardcoded-authetication.service';
import { AuthService } from 'src/app/service/seguridad/auth.service';


@Component({
    selector: 'app-respuesta',
    templateUrl: './respuesta.component.html',
    styleUrls: ['./respuesta.component.css'],
    providers: [],
    standalone: false
})
export class RespuestaComponent implements OnInit {

  refPayco: string = ''
  transactionResponse: any;
  url: Foto
  pixel: boolean = false
  pixel2: boolean = false
  pixel3: boolean = false
  orden: Orden
  transacciones:any []
  eventoId: number
  ordenId
  banco:string
  valor:number
  constructor(
    private ordenService: OrdenDataService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private metaPixelService: MetaPixelService,
    private gaService: GoogleAnalyticsService,
    private eventoService: EventoDataService,
    private googleAnalyticService: GoogleAnalyticService
  ) {

  }

  ngOnInit(): void {



    // Esperar a que se complete la carga de la sesión
    this.authService.cargarSesionDesdeLocalStorage();

    // Solo continuar si la sesión se cargó correctamente o si ya estamos autenticados
      this.activatedRoute.paramMap.subscribe(params => {
        this.ordenId = params.get('idOrden');
        this.ordenService.getRespuestaOrden(this.ordenId).subscribe({
          next: response => {
            console.log(response)
            this.orden = response.orden;
            this.transacciones = response.transacciones;
            this.eventoId = response.orden.eventoId

            // Obtener el perfil del evento para conseguir el Meta Pixel
            this.eventoService.getEventoIdPerfil(this.eventoId.toString()).subscribe({
              next: eventoResponse => {
                // Obtener el Meta Pixel del evento
                const metaPixelLink = eventoResponse['evento']?.metaPixel;
                const googleAnalytic = eventoResponse['evento']?.googleAnalytic;
                if (metaPixelLink) {
                  this.metaPixelService.inicializarPixelSiEsNecesario(metaPixelLink);
                }

                if (this.orden.estado == 1) {
                  const rawValue = this.orden.valor_orden;
                  const currency = 'COP'; // Código ISO para pesos colombianos
                
                  if (typeof rawValue !== 'number' || isNaN(rawValue) || rawValue <= 0) {
                    console.error('Valor de orden inválido:', rawValue);
                    return;
                  }
                
                  // Enviar el valor exacto (194000 = 194,000 COP)
                  this.metaPixelService.trackPurchase(rawValue, currency);
                  
                  console.log(`Evento Purchase enviado: ${rawValue} ${currency}`);
                  
                  this.googleAnalyticService.trackPurchase(googleAnalytic);
                } else {
                  console.warn('Orden no aprobada. No se rastreó Purchase.');
                }
              },
              error: error => {
                console.error('Error al obtener el perfil del evento:', error);
              }
            });

            if (this.transacciones) {
              this.banco = this.transacciones[this.transacciones.length-1].metodoNombre;
              this.valor = this.transacciones[this.transacciones.length-1].amount;
            }
            //google analytics
            this.gaService.gtag('event', 'purchase', {
              transaction_id: this.ordenId,
              value: this.valor,
              currency: 'COP'
            });
            ;
            this.eventoId = response.orden.eventoId;
          },
          error: error => {
            this.orden = new Orden();
            console.error('Error al obtener la orden:', error);
          }
        });
      });

  }
}
